import styled from "styled-components"; 

export const Xfooter  = styled.div`
position : absolute;
width: 100%;  
margin-left: -7.4%;
`